import { graphql } from '@/generated/gql';

export const DEMAND_AWARDING_QUERY = graphql(/* GraphQL */ `
  query DemandAwarding($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        competitiveBiddingRule {
          id
          isMaskedBidding
        }
        demandRequest {
          id
          currency
          totalValue
          lineItems {
            id
            title
            description
            quantity
            expectedPricePerUnit
            commodityId
            unitId
            commodityGroupId
            organizationId
            deliveryLocationId
            preferredSupplierId
            internalId
            position
            totalValue
          }
        }
        awardingStatus {
          entityId
          entityVariant
          field
          status
        }
        awardingSettings {
          isPartialAwardingEnabled
          notifications {
            options {
              informSupplier
              dismissOtherSuppliers {
                show
                defaultValue
              }
              informAwardedSupplier {
                show
                defaultValue
              }
              informDismissedSupplier {
                show
                defaultValue
              }
            }
          }
        }
        negotiationCases {
          nodes {
            id
            isAwardable
            sequenceNumber
            status
            processStatus
            sourceReferences {
              id
              sourceReference
              url
            }
            supplier {
              id
              name
              internalId
              externalReference
              contact {
                id
                internalId
                email
                firstName
                language
                lastName
                mobile
                phone
              }
              location {
                id
                internalId
                address
                city
                countryCode
                postalCode
              }
            }
            variant
            quote {
              ... on TsrctQuoteInterface {
                id
                supplierReference
                currency
                totalValue
                lineItems {
                  id
                  title
                  position
                  description
                  quantity
                  unitId
                  pricePerUnit
                  totalValue
                  status
                }
                shipmentTerms {
                  earlyDeliveryAt
                  lateDeliveryAt
                }
              }
              ... on TsrctNegotiatedQuote {
                discount
                totalPriceDiscount
                totalDiscountedValue
                lineItems {
                  discount
                  discountedPricePerUnit
                  totalDiscountedValue
                  isAwardable
                  demandRequestItemId
                  negotiationFailedReason
                  negotiationFailedReasonText
                }
              }
            }
          }
          totalCount
        }
      }
    }
  }
`);
